import { faArrowRight, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useState } from 'react'
import './CreateBlueprint.css'
import { Button,  DatePicker,  Input,  InputNumber,  Modal, Select, Spin, Switch } from 'antd';
import { Col, Row } from 'reactstrap';
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import AwsServerService from '../../common/util/AwsServerService';
import ReactInputMask from 'react-input-mask';
import { NumericFormat } from 'react-number-format';
import { NewUserPicker } from '../../common/UserPicker/NewUserPicker';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs'; 
import HierarchicalDropdown from '../Roles/HierarchicalDropdown';
import { row } from 'mathjs';
import TaskService from '../../common/util/TaskService';
import { AppDataRequired } from '../../App';
import { UserPicker } from '../../common/UserPicker/UserPicker';
const { Option, OptGroup } = Select;

export default function AfterFieldUpdate({flowId, selectedEdgeData, editFlow, isBlueprintLocked}) {
    const [open, setOpen] = useState(false);
    const [rows, setRows] = useState([]); 
    const [loader, setLoader] = useState(false);
    const [rowsToRender, setRowsToRender] = useState([]);
    const [firstOptions, setFirstOptions] = useState([]);
    const { AllUsers } = useContext(AppDataRequired); 
    const userInfo = JSON.parse(localStorage.getItem('userinfo'));
    const fieldsToIgnore = ["Deal_Name","Account_Name","City","State","Is_NYC_Project","Tidal_Wetlands","Fresh_Water_Wetland","Flood_Hazard"];
    const fieldsToAdd = [];
    const [error, setError] = useState(false);
   
    useEffect(()=>{
        AwsServerService.getCriteriaFields().then(res=>{  
            let data=res?.data?.filter(element=>!fieldsToIgnore.includes(element.field));
            setFirstOptions(data)
        })
    },[])
    useEffect(()=>{
        setError(false);
        if(rowsToRender.length>0){
            setRows([...rowsToRender]);
        }else{
            setRows([{initial:'',second:''}])
        }
    },[open])
    const getDataFunction = ()=>{
        if(selectedEdgeData){
            setLoader(true);
            AwsServerService.getTransitionFieldUpdatesById(flowId,selectedEdgeData?.id).then(res=>{
                let resArray = res?.data;
                let dataArray=[];
                if(resArray && resArray?.length>0){
                  resArray.forEach(element=>{
                  let obj={}; 
                  obj['initial'] = element?.FieldName;
                  obj['second'] = element?.FieldValue;
                  obj['type'] = element?.DataType;
                  obj['id'] = element?.ROWID;
                  dataArray.push(obj);
                   })
                   setRows([...dataArray]);
                   setRowsToRender([...dataArray]);
                  }else{
                   setRows([{initial:'',second:''}])
                   setRowsToRender([]);
                  }
                  setLoader(false);
              }).catch(err=>{
                console.log("unable to fetch field updates records");
                setLoader(false);
                setRows([{initial:'',second:''}])
                setRowsToRender([]);
              }) 
          }
    }
    useEffect(()=>{
        getDataFunction();
      },[selectedEdgeData])
    const [dealStatus,setDealStatus]=useState([]);
    useEffect(()=>{
      TaskService.GetDealStatus()
      .then((res) => { 
        setDealStatus(res);
      })
      .catch((err) => {
        console.log(err);
      });
    },[])
    const TypeInputComponents = {
        "TEXT": (field, index) => <Input  
            className={`Input-Text`} 
            value={field?.second} 
            onChange={(e) => { 
                handleChangeObj(e.currentTarget.value,'second',index,field.type) 
            }} 
        />, 
        "PHONE": (field, index) => <ReactInputMask 
            type="text"
            mask="(999) 999-9999"
            maskChar='_'
            className={`form-control arrow-hide createdeal-textfield`}
            name="phoneNumber" id="phoneno"
            placeholder="(###) ###-####"
            minLength={3}
            value={field.second ? field.second : ''} 
            onKeyDown={(evt) =>
                ((evt.keyCode > 64 && evt.keyCode < 91) || evt.key === ".") &&
                evt.preventDefault()
            }
            onChange={(e) => {
                e.target.value = e.target.value.trimStart();
                let value = e.target.value
                var value1 = value.replace(/[-#*$+/?=%() ]/g, '')
                let onlyNo = value1.replace(/\D/g, '');
                if (onlyNo.length > 10) {
                    return
                }
                handleChangeObj(onlyNo,'second',index,field.type) 
            }}
            onBlur={(e)=>{
                var v1 = e.currentTarget.value.replace(/[-#*$+/?=%() ]/g, "");
                let value1= v1.replace(/\D/g, '');  
            }}
        />,
        "NUMBER": (field, index) => <InputNumber style={{ width: "100%" }} min={0}
            step={field?.Precision ? Number(field?.Precision) : 1}
            precision={field?.Precision ? field?.Precision?.split(".")[1]?.length : 0} 
            className={`Input-Text`}
            value={field.second}
            onChange={(e) => { 
                handleChangeObj(e,'second',index,field.type) 
            }} 
        />,
        "CURRENCY": (field, index) => <NumericFormat 
        className="custome-currency-input"
        name="currency"
        step={field?.Precision ? Number(field?.Precision) : 1}
        placeholder="Enter amount"
        value={field.second}
        defaultValue={0}
        thousandSeparator 
        decimalScale={field?.Precision}
        onValueChange={(e) => {
            handleChangeObj(e.value,'second',index,field.type) 
        }} 
        prefix="$"
      />,
        "USER": (field, index) => <HierarchicalDropdown
            styles={{width:'100%',height:'auto'}} 
            key={"rolepicker"+index}
            isMulti={true}
            limit="1"
            GroupName={["Zoho", "Role"]}
            handleChangeUser={(value, option) => { 
                handleChangeObj(value,'second',index,field.type) 
            }}
            selectedUsers={field.second} 
        />, 
        "DATE": (field, index) => <><DatePicker 
            className={`Input-Date-FieldUpdate`}  
            format="MM-DD-YYYY" 
            value={field.second!="" ? dayjs(field.second) : dayjs(new Date())}
            onChange={(date, dateString) => {
                console.log(dateString); 
                handleChangeObj(dayjs(dateString).format('YYYY-MM-DD'),'second',index,field.type) 
            }} 
        ></DatePicker></>, 
        "PICKLIST": (field, index) => <Select   
                    style={{width: '20.7em',height: 'auto'}}
                    value={field.second}
                    onChange={(value) => { 
                        handleChangeObj(value,'second',index,field.type) 
                    }} 
                    allowClear
                >
                    {dealStatus?.map((option, idx) => (
                        <Option key={idx} value={option.display_value}>
                            {option.display_value}
                        </Option>
                    ))}
                </Select>
                }
    
    const handleAddRow = (row) => { 
        if(rows && rows.length==1 && (rows[0].initial=='' || rows[0].second==''||rows[0].second==undefined||rows[0].initial==undefined)){
            setError(true);
        }else if(row.initial==''||row.second==''||row.second==undefined||row.initial==undefined){
            setError(true);
        }else{
            setRows([...rows, { id: Date.now(),initial:'',second:''}]);
            setError(false);
        }
    };
    const handleRemoveRow = (id, keyToRemove) => {
        if(keyToRemove==0 && rows.length==1){
            setRows([{ id: Date.now(),initial:'',second:''}])
            return;
        }
        const updatedRows = rows.filter((row) => row.id !== id); 
        setRows(updatedRows);
    };
    const handleChangeObj = (value, field, index,ftype) => { 
        let type='';
        if(field=='initial'){
            let item=firstOptions?.find(el=>el.ROWID==value.key); 
            type=item.type;
        }else{
            type=ftype;
        }
        const updatedRows = [...rows];  
        if(type=='DATE' && updatedRows[index]?.second==''){
            updatedRows[index] = {  
                ...updatedRows[index],
                [field]: value,
                'second':dayjs().format('YYYY-MM-DD'),
                'type':type,  
            };
        }else{ 
        updatedRows[index] = {  
            ...updatedRows[index],
            [field]: value,
            'type':type,  
        };
        }
        setRows(updatedRows);  
        console.log("udpatedROWS",updatedRows); 
    }; 
    const onSave = async (data) => {  
        let a = [...rowsToRender];
        const dbIds = a.map((record) => record.id);
        if (data && data.length == 1 && (rows[0].initial=='' || rows[0].initial==undefined) && (rows[0].second==''||rows[0].second==undefined)) {
            AwsServerService.DeleteUpdateFields(dbIds).then(res=>{
                getDataFunction();
            })
            return;
        } 
        const idsToUpdate = data.filter(idss => dbIds.includes(idss.id)); 
        let updatePromises = [];
        if (idsToUpdate && idsToUpdate.length > 0) {
            updatePromises = idsToUpdate.map(async (element) => {
                let obj = {
                    FieldName: JSON.stringify(element.initial),
                    FieldValue: element.second,
                    DataType: element.type,
                    MODIFIEDBY: userInfo.email_id,
                    ROWID: element.id
                };
                return await AwsServerService.updateUpdateFields(obj);
            });
        } 
        const selectedIds = data.map((record) => record.id);
        const idsToRemove = dbIds.filter((id) => !selectedIds.includes(id));
        const idsToAdd = selectedIds.filter((id) => !dbIds.includes(id)); 
        let removePromise = idsToRemove && idsToRemove.length > 0 ? AwsServerService.DeleteUpdateFields(idsToRemove) : Promise.resolve(); 
        let addPromises = [];
        if (idsToAdd && idsToAdd.length > 0) {
            addPromises = idsToAdd.map(async (id) => {
                let element = data?.find(el => el.id === id);
                try {
                    let payload = {
                        CREATEDBY: userInfo.email_id,
                        MODIFIEDBY: userInfo.email_id,
                        TransitionEdgeId: selectedEdgeData?.id,
                        TaskFlowId: flowId,
                        FieldName: JSON.stringify(element.initial),
                        FieldValue: element.second,
                        DataType: element.type,
                    };
                    return await AwsServerService.CreateUpdateFields(payload);
                } catch (error) {
                    console.error("Error:", error);
                }
            });
        } 
        try {
            await Promise.all([ ...updatePromises,  removePromise,  ...addPromises ]); 
            alert('Fields updated successfully');
            getDataFunction();  
        } catch (err) {
            console.error('Error during API calls:', err);
            alert('Field update failed');
        }
    }
    
    const fieldUpdateModal = () =>{
        return (
            <div>
            <Modal
                open={open}
                // open={false}
                wrapClassName={"Add-criteria-Wrapper"}
                rootClassName="Add-criteria-Root-Wrapper"
                draggable
                title={"Update Fields"}
                maskClosable={false}
                width={600}
                style={{ bottom: '2rem', right: '9rem', zIndex: "1000", minHeight: "" }}
                onCancel={() => setOpen(false)}
                footer={[
                    <div className='Criteria-Footer'>  {error ? <span className='Error' color='red'>
                       Please fill all required fields.
                    </span>:<span></span>}
                        <Button type="primary" onClick={() => { 
                            if(rows.length>1 && rows.some(e=>e.initial==''||e.second==''||e.second==undefined)){
                                setError(true);
                            } else if(rows.length == 1 && rows[0].initial!='' && (rows[0].second==''||rows[0].second==undefined)){
                                setError(false);
                            } else if(rows.length == 1 && rows[0].second!='' && rows[0].second!=undefined && (rows[0].initial==''||rows[0].initial==undefined)){
                                setError(false); 
                            }else{
                                onSave(rows)
                                setOpen(false)
                            }
                        }}>{rowsToRender.length>0?`Update`:`Save`}</Button>
                    </div>
                ]}
            >
            {rows.map((row, index) => { 
                    return <>
                    <Row key={row.id} style={{display: "flex","align-items":"center",marginBottom: '10px' }} align="middle">
                         <Col className="pr-0 mr-0" sm={5}>
                            <Select
                                // mode="multiple"
                                style={{ width: "100%", height: 'auto' }}
                                placeholder="Select"
                                value={row.initial}
                                id='initial'
                                onChange={(e, option) => handleChangeObj(option,'initial',index)}
                                // options={firstOptions}
                            >  
                            <OptGroup label="Deal Fields">
                                {firstOptions?.filter(item => item.module === 'Project').map(item => (
                                <Option key={item.ROWID} value={`${item.field}__Deal`}>
                                    {item.label}
                                </Option>
                                ))}
                            </OptGroup>
                            <OptGroup label="Task Fields">
                                {firstOptions?.filter(item => item.module === 'Task').map(item => (
                                <Option key={item.ROWID} value={`${item.field}__Task`}>
                                    {item.label}
                                </Option>
                                ))}
                            </OptGroup>
                            </Select>
                        </Col>
                        <Col className='p0m0' sm={1} style={{fontSize: 'large',fontWeight: '600',color: '#5b6c97'}}>
                        =
                        </Col>
                        <Col sm={5}>
                        {TypeInputComponents[row['type']]? TypeInputComponents[row['type']](row, index)
                        : TypeInputComponents['TEXT'](row, index)}
                        
                            {/* <Select 
                                value={row.second=='0'?'':row.second}
                                style={{ width: "100%", height: 'auto' }}
                                placeholder="Select"
                                id='middel'
                                onChange={(e, option) => handleChangeObj(option,'second',index)}
                                options={secondOptions}
                            /> */}
                        </Col> 
                        <Col className='p0m0' sm={1}> 
                             <Button
                                icon={<MinusCircleOutlined />}
                                ghost
                                onClick={() => handleRemoveRow(row.id, index)}
                                style={{ border: "none" }}
                                danger
                            /> 
                            <Button
                                onClick={()=>handleAddRow(row)}
                                icon={<PlusCircleOutlined width={10} height={10} />}
                                style={{ border: "none" }}
                            />
                        </Col>
                    </Row></>
                })}
            </Modal>
        </div>
        )
    }
  return (
    <div className="Email-Template-Wrapper" style={{width: '37em', overflow: 'scroll',height: '19vh'}}>
        {fieldUpdateModal()}
        <div className="AddFieldButton"
                style={isBlueprintLocked ? {pointerEvents: "none", opacity: 0.5, cursor: "not-allowed", height: '2rem', display: 'flex',alignItems: 'center', justifyContent: 'center', cursor: "pointer", } : {height: '2rem', display: 'flex',alignItems: 'center', justifyContent: 'center', cursor: "pointer"}}
                onClick={(e) => {setOpen(true)}}
              >
                <FontAwesomeIcon style={{ "margin-right": "7px" }} icon={faPlus} />
                {"Add"}
                </div> 
        {rowsToRender.length>0 && <div className='renderUpdateFields' style={isBlueprintLocked ? {pointerEvents: "none", opacity: 0.5, cursor: "not-allowed", flexWrap:'wrap'} : {flexWrap:'wrap'}} onClick={e=>setOpen(true)}>
                {loader&&<div><Spin/></div>}
                {rowsToRender?.map(el=> { 
                    let first = el?.initial?.children;
                    let name=el?.initial?.value?.split('__');
                    return(
                    <div className='FieldCard'>
                        {name[1]+"'s "+first} <span style={{width: '1.5em',marginLeft: '.5em',color: '#5a8ecf'}}><FontAwesomeIcon icon={faArrowRight}/></span>  {first=='End Date'?dayjs(el.second).format('MM-DD-YYYY'):
                        (first=='Assignee'||first=='Supervisor')?
                        <span>  <img
                        style={{ 
                          height: "25px",
                          width: "25px",
                          borderRadius: "50%",
                        }}
                        className="Icon"
                        src={
                          "https://contacts.zoho.com/file?ID=" +
                          el.second +
                          "&fs=thumb"
                        }
                      /> {AllUsers?.filter((d) => d.zuid==el.second)[0]?.full_name}</span>:el.second} 
                    </div>
                    )}
                )}
            
            </div>}
    </div>
  )
}
